var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "slide-toggle",
    class: {
      'st-reverse': _vm.reverse,
      'st-outline': _vm.outline,
      'st-animate': _vm.animate
    }
  }, [_c('input', {
    attrs: {
      "id": _vm.inputId,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('input', !_vm.value);
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_c('div', {
    attrs: {
      "data-unchecked": _vm.offLabel,
      "data-checked": _vm.onLabel
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };